import { Text } from '@rsos/base-components';
import type { PreconfiguredResponse } from '@rsos/reduxDataStore/src/features/preconfiguredMessages/preconfiguredMessagesAPI';
import {
  TableError,
  TableLoading,
  EmptyState,
  NoResultsState,
} from '../tableShared';
import {
  Wrapper,
  TableWrapper,
  EmptyStateCell,
} from '../tableShared/index.styles';
import RsosMessagesTableRow from './TableRow';

const TABLE_HEIGHT = 244;
const TABLE_HEIGHT_NO_HEADER = 200;

const RsosMessagesTable = ({
  messages,
  searchTerm,
  isLoading,
  isError,
}: {
  messages: PreconfiguredResponse[];
  searchTerm: string;
  isLoading: boolean;
  isError: boolean;
}) => {
  if (isLoading) return <TableLoading height={TABLE_HEIGHT} />;
  if (isError) return <TableError height={TABLE_HEIGHT} />;
  return (
    <Wrapper>
      <Text size="large" fontWeight="bold" mb={16}>
        RapidSOS Suggested Messages
      </Text>
      <TableWrapper height={TABLE_HEIGHT}>
        <table>
          <thead>
            <tr>
              <th>Message Title</th>
              <th>Message Body</th>
              <th>Enabled</th>
            </tr>
          </thead>
          <tbody>
            {messages.length === 0 ? (
              <tr>
                <EmptyStateCell height={TABLE_HEIGHT_NO_HEADER}>
                  {searchTerm ? (
                    <NoResultsState />
                  ) : (
                    <EmptyState owner="rsos" />
                  )}
                </EmptyStateCell>
              </tr>
            ) : (
              messages.map(rsosMessage => (
                <RsosMessagesTableRow
                  key={rsosMessage.id}
                  rsosMessage={rsosMessage}
                />
              ))
            )}
          </tbody>
        </table>
      </TableWrapper>
    </Wrapper>
  );
};

export default RsosMessagesTable;
